{
  "title": "Итоги обогащения",
  "ciType": "Тип КЕ",
  "useLastEnrichment": "Последние обогощение",
  "cleanTable": "Очистить таблицу",
  "ciTypesTable": {
    "columns": {
      "ci": "Имя КЕ",
      "attributes": "Атрибуты",
      "links": "Связи",
      "record": "Запись",
      "timestamp": "Дата",
      "progress": "Прогресс"
    }
  },
  "import": {
    "columns": {
      "status": "Статус",
      "resource_type": "Сущность",
      "actions_conflict": "Действие при конфликте",
      "message": "Сообщение"
    },
    "statuses": {
      "new": "Новый",
      "success": "Успешно",
      "skipped": "Пропущено",
      "conflict": "Конфликт",
      "error": "Ошибка"
    },
    "messages": {
      "common_action": "Выберите общее действие",
      "placeholder": "Новое имя",
      "entities": {
        "cit": "Тип КЕ",
        "enrichment_plan": "План обогащения",
        "attribute": "Атрибут",
        "dashboard": "Дашборд",
        "monitoring_template": "Шаблон мониторинга",
        "job": "Задание",
        "hi_type": "Тип Индикатора здоровья"
      },
      "conflict_actions": {
        "replace": "Ресурс успешно обновлен",
        "rename": "Ресурс успешно переименован",
        "success": "Ресурс успешно создан",
        "error": "Произошла неизвестная ошибка",
        "skipped": "Импорт пропущен пользователем",
        "canceled": "Импорт отменен"
      },
      "options": {
        "skip": "Пропустить действие",
        "replace": "Заменить существующий",
        "rename": "Переименовать"
      }
    }
  }
}